<template>
    <div style="width: 100%; height: 100%;">
        <div>
            <baidu-map
                @ready="initMap"
                :zoom="12"
                :min-zoom="10"
                :max-zoom="18"
                center="济南市"

                style="height: 100vh;width: 100%"
                :scroll-wheel-zoom="true">
            </baidu-map>
        </div>

        <!-- 搜索区域 -->
        <div class="search_div">
            <div style="display: flex;">
                <el-input v-model="form.name" placeholder="输入网点名称搜索" style="margin-right: 10px;"></el-input>
                <el-button type="primary" @click="search" size="mini" style="background-color: #2c3e50">搜索</el-button>
                <el-button type="primary" @click="initPoint" size="mini" style="background-color: #2c3e50">全部店铺</el-button>
            </div>
        </div>

        <!-- 搜索结果列表 -->
        <el-drawer
            style="box-sizing: border-box;"
            size="300px;"
            :with-header="false"
            :visible.sync="drawer"
            :direction="direction">
            <div style="background-color: #2c3e50;width: 100%; height: 100%; padding: 10px; overflow-y: scroll;">
                <!-- 房屋信息 -->
                <div class="house_div" v-for="house in houses" @click="showHouseMarkPoint(house.lng,house.lat,house.xiaoqu)">
                    <div class="left_div">
                        <!--<img :src="'http://localhost:8888/house/file/download?fileName='+house.image" style="background-color: aquamarine; width: 180px; height: 100%;"/>-->
                    </div>
                    <div class="right_div" @click="pointView(house)">
                        <div style="align-self: flex-start; font-weight: 500;">
                        <div class="content_div_label">店铺名称：</div>{{house.name}}</div>
                        <div><div class="content_div_label">编号：</div>{{house.storeNo}}</div>
                        <div><div class="content_div_label">类型：</div>{{house.type}}</div>
                        <div><div class="content_div_label">公司名称：</div>{{house.companyName}}</div>
                        <div><div class="content_div_label">负责人：</div>{{house.person}}</div>
                        <div><div class="content_div_label">联系电话：</div>{{house.tel}}</div>
                        <div><div class="content_div_label">地址：</div>{{house.address}}</div>
                        <div style="align-self: flex-start; font-weight: 500;"><div class="content_div_label">主营业务：</div>{{house.saleType}}</div>
                    </div>
                </div>
            </div>

        </el-drawer>

    </div>
</template>


<script>
import jsonData from "@/assets/api/data.json"
import iconUrl from "@/assets/location.png"
export default {
    data(){
        return{
            map: null,
            drawer: false,
            center: "济南市",
            direction:"rtl",
            zoom: 14,
            form: {
                name: "",
            },
            mapStyle:{
                features: ["road", "building","water","land"],//隐藏地图上的poi
               styles:"midnight",

            },
            houses: [],
            //房屋地图位置标记点
            houseMarkPoint: {},
            xiaoqu: ""
        }
    },
    mounted() {

    },
    methods: {
        initMap({BMap, map}) {
            this.map = map
            let city = "济南市"
            //let region = "丰台区"
            // this.drawPolygon(city)

            this.initPoint();
            //this.addRegionLabel(city,region)
        },
        // 绘制行政区划轮廓
        drawPolygon(regionName) {
            let that = this
            let bdary = new BMap.Boundary();
            bdary.get(regionName, function (rs) {
                //轮廓的总数 —— 有的区由多个封闭区域组成
                let count = rs.boundaries.length;
                if (!count) {
                    console.log('未能获取到当前输入的行政区域');
                    return;
                }
                for (let i = 0; i < count; i++) {
                    //创建多边形覆盖物
                    let ply = new BMap.Polygon(rs.boundaries[i],
                        {
                            strokeColor:"#6686A9",    //边线颜色。
                            fillColor:"#81B3EB",      //填充颜色。当参数为空时，圆形将没有填充效果。
                            strokeWeight: 2,       //边线的宽度，以像素为单位。
                            strokeOpacity: 0.8,    //边线透明度，取值范围0 - 1。
                            fillOpacity: 0.5,      //填充的透明度，取值范围0 - 1。
                            strokeStyle: 'solid' //边线的样式，solid或dashed。
                        }
                    );
                    // 给覆盖物添加点击事件
                    //ply.addEventListener('click', function () {
                    //    alert("我是:" + regionName)
                    //    // 改变自己的透明度
                    //    // this.setFillOpacity(0.6)
                    //});
                    //添加覆盖物
                    that.map.addOverlay(ply);
                }
            })
        },
        // 获取行政区划的坐标
        getReigonLocation(city, region) {
            return this.$http.get("/baiduMapAPI/place/v2/search", {
                params: {
                    query: region,
                    region: city,
                    output: 'json',
                    city_limit: true,
                    ak: this.GLOBAL.baiduMapAK
                }
            }).then(res => {
                let location = res.data.results[0].location
                return Promise.resolve(location);
            })
        },
        // 添加行政区划文本标注
        async addRegionLabel(data) {
            // 创建文本标注对象
            let label = new BMap.Label(data.name,
                {
                    position: new BMap.Point(data.longitude, data.latitude),
                    offset: new BMap.Size(-80, 15)    //设置文本偏移量
                }
            );
            label.setStyle({
                color: "#F56C6C",
                fontSize: "14px",
                fontFamily: "微软雅黑",
                background: "none",
                border: "none",
                fontWeight: 'bold'
            });
            //在地图上添加文本标注对象
            this.map.addOverlay(label);

            //图标
            const point = new BMap.Point(data.longitude, data.latitude);
            const icon = new BMap.Icon(iconUrl, new BMap.Size(32, 32));
            icon.setImageSize(new BMap.Size(32,32));
            const marker = new BMap.Marker(point, { icon });
            this.map.addOverlay(marker); //添加点到地图上

            var opts = {
                width : 280,     // 信息窗口宽度
                height: 280,     // 信息窗口高度
                title : "店铺信息" , // 信息窗口标题
                panel  : "panel",
            }
            const content = `
                <div class="content_div">
                    <div style="align-self: flex-start; font-weight: 500;"><div class="content_div_label">店铺名称：</div>`+data.name+`</div>
                    <div><div class="content_div_label">编号：</div>`+data.storeNo+`</div>
                    <div><div class="content_div_label">类型：</div>`+data.type+`</div>
                    <div><div class="content_div_label">公司名称：</div>`+data.companyName+`</div>
                    <div><div class="content_div_label">负责人：</div>`+data.person+`</div>
                    <div><div class="content_div_label">联系电话：</div>`+data.tel+`</div>
                    <div><div class="content_div_label">地址：</div>`+data.address+`</div>
                    <div style="align-self: flex-start; font-weight: 500;"><div class="content_div_label">主营业务：</div>`+data.saleType+`</div>
                </div>
              `;
            var infoWindow = new BMap.InfoWindow(content, opts);  // 创建信息窗口对象
            marker.addEventListener("click", function(){
                this.map.openInfoWindow(infoWindow,point); //开启信息窗口
            });
        },
        //查询网点
        search(){
            this.houses=[]
            const storeData=jsonData.data.filter(item => item.name.includes(this.form.name));
            storeData.forEach(item=>{
                this.houses.push(item)
            })
            this.drawer = true;
            // //发送axios请求获取后端的数据
            // this.axios({
            //     method: "get",
            //     url: "./api/data.json",
            //     data: this.form
            // }).then((result)=>{
            //     console.log("房屋搜索结果",result.data);
            //     //将从后端拿到的房屋搜索信息存到houses中
            //     this.houses = result.data;
            //     //弹出右边的信息框
            //     this.drawer = true;
            // });
        },
        initPoint(){
            jsonData.data.forEach(item=>{
                this.addRegionLabel(item)
            })
        },
        pointView(data){
            //清空marker点
            this.map.clearOverlays();
            //加载选中店铺
            this.addRegionLabel(data)
        },
        showHouseMarkPoint(lng,lat,xiaoqu){
            var point = {
                lng: lng,
                lat: lat
            };
            this.xiaoqu = xiaoqu;
            //改变房屋的地图位置
            this.houseMarkPoint = point;
            //改变地图的中心点
            this.center = point;
            //改变地图的缩放比例,最大缩放比例是19
            this.zoom = 19;
            this.drawer = false;
        }
    }
}
</script>
<style>
.BMap_cpyCtrl {
    display: none!important;
}
.anchorBL {
    display: none!important;
}

.map_div{
    width: 100%;
    height: 100%;
    /* background-color: aliceblue; */
}
.el-drawer rtl{
    /*background-color: rgba(22, 31, 38, 0.87) !important;*/
}
.el-drawer__header {
    margin-bottom: 0 !important;
    padding: 0 !important;
}
.search_div{
    overflow-x: hidden;
    width: 450px;
    height: auto;
    background-color: rgba(22, 31, 38, 0.87);
    position: absolute;	/* 固定定位 */
    top: 10px;
    left: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    opacity: 1;
    padding: 10px;
    box-sizing: border-box;
}
.search_div input{
    background-color: rgba(22, 31, 38, 0.87);
}
.house_div{
    color: white;
    border: 1px solid rgba(106, 117, 198, 0.8);
    width: 99%;
    height: auto;
    background-color: rgba(22, 31, 38, 0.87);
    margin-bottom: 5px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    display: flex;
    overflow-y: hidden;	/* 超出的部分全部隐藏 */
    overflow-x: hidden;
}

.left_div{
    height: 100%;
}

@media screen and (max-width: 991px){
    .search_div{
        width: 94%;
        height: auto;
        background-color: rgba(22, 31, 38, 0.87);
        position: absolute;	/* 固定定位 */
        top: 10px;
        left: 3%;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        opacity: 1;
        padding: 10px;
        box-sizing: border-box;
    }
}
.right_div{
    font-size: 12px;
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    padding: 10px;
    box-sizing: border-box;
    text-align: left;
}
.right_div div{
    line-height: 25px;
    overflow: hidden;
}

.content_div{
    font-size: 12px;
    height: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    padding: 5px 0;
    box-sizing: border-box;
}
.content_div div{
    height:auto;
    line-height: 25px;
}
.content_div_label{
    /*width:60px;*/
    text-align: right;
    float: left;
}
</style>
